import React, { useState, useEffect } from 'react';
import { Link, Router, navigate } from '@reach/router';

import { AnimatePresence } from 'framer-motion';
import StarterForm from './starter-form';
import StepOne from './step-one';
import StepTwo from './step-two';
import StepThree from './step-three';
import BrandedConfirmation from './branded-confirmation';
import BrandedRoute from './branded-route';
import BrandedModal from './branded-modal';

const BrandedPage = () => {
    const [brandedSettings, setBrandedSettings] = useState({
        completed: false,
        first_name: '',
        last_name: '',
        email: '',
        phone: '',
        company: '',
        interested_in: [],
        deadline: '',
        design_description: '',
        product_styles: [],
        reference_files: [],
        product_colors: {
            primary_color: '',
            secondary_color: '',
            accent_1: '',
            accent_2: '',
            accent_3: '',
        },
    });

    const [modalActive, setModalActive] = useState(false);

    function saveProgress() {
        if (typeof window !== 'undefined') {
            localStorage.setItem(
                'brandedProgress',
                JSON.stringify(brandedSettings)
            );
        }
    }

    function brandedInit() {
        if (typeof window !== 'undefined') {
            let previousValues = JSON.parse(
                localStorage.getItem('brandedProgress')
            );
            setBrandedSettings(previousValues);
        }
    }

    function startFresh() {
        if (typeof window !== 'undefined') {
            setBrandedSettings({
                completed: false,
                first_name: '',
                last_name: '',
                email: '',
                phone: '',
                company: '',
                interested_in: [],
                deadline: '',
                design_description: '',
                product_styles: [],
                reference_files: [],
                product_colors: {
                    primary_color: '',
                    secondary_color: '',
                    accent_1: '',
                    accent_2: '',
                    accent_3: '',
                },
            });
            setModalActive(false);
            navigate('/branded');
        }
    }

    function resumeProgress() {
        setModalActive(false);
    }

    useEffect(() => {
        saveProgress();
    }, [brandedSettings]);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            let previousValues = JSON.parse(
                localStorage.getItem('brandedProgress')
            );
            console.log('previousValues', previousValues);
            if (
                window.location.pathname !== '/branded' &&
                brandedSettings.completed === false
            ) {
                setModalActive(true);
            }
        }
    }, []);

    return (
        <>
            <Router>
                <StarterForm
                    brandedSettings={brandedSettings}
                    setBrandedSettings={setBrandedSettings}
                    path="/branded"
                    brandedInit={brandedInit}
                />

                {/* Step 1 */}
                <BrandedRoute
                    component={StepOne}
                    brandedSettings={brandedSettings}
                    setBrandedSettings={setBrandedSettings}
                    path="/branded/step-1"
                    brandedInit={brandedInit}
                />
                {/* Step 2 */}
                <BrandedRoute
                    component={StepTwo}
                    brandedSettings={brandedSettings}
                    setBrandedSettings={setBrandedSettings}
                    path="/branded/step-2"
                    brandedInit={brandedInit}
                />

                {/* Step 3 */}
                <BrandedRoute
                    component={StepThree}
                    brandedSettings={brandedSettings}
                    setBrandedSettings={setBrandedSettings}
                    path="/branded/step-3"
                    brandedInit={brandedInit}
                />

                {/* Confirmation */}
                <BrandedRoute
                    component={BrandedConfirmation}
                    brandedSettings={brandedSettings}
                    setBrandedSettings={setBrandedSettings}
                    path="/branded/confirmation"
                    brandedInit={brandedInit}
                />
            </Router>
            <AnimatePresence>
                {modalActive && (
                    <BrandedModal
                        startFresh={startFresh}
                        resumeProgress={resumeProgress}
                    />
                )}
            </AnimatePresence>
        </>
    );
};

export default BrandedPage;
